define('MessageView',[
    'underscore',
    'backbone',
    'jquery',
    'app',
    'SubView',
    'LocalStorage'
], function (
    _,
    Backbone,
    $,
    app,
    SubView,
    LocalStorage
) {

    return Backbone.View.extend(SubView).extend({
        page:'',
        message: {},
        initialize: function (location, options) {
            var view = this;
            view.subviews = [];
            view.location = location;
            view.options = _.defaults(options,{});
            view.listenTo(view.options.messages||app.getMessages(),'update reset', view.onUpdate);
            view.loadMessage();
        },
        getMessage:function(){
            return app.getMessage(this.location,this.options);
        },
        loadMessage:function(){
            var view = this,
                message = view.getMessage();
            if(message){
                // on charge le message (si il existe)
                // si il y a un message nouveau ou différent
                view.message = message;
                view.page = message.getPage();
                view.listenTo(message,'change',view.onUpdate);
                view.render();
            }else if(!message && view.message){
                // suppression d'un message
                view.stopListening(view.message);
                view.$el.remove();
            }
        },
        onUpdate:function(){
            this.loadMessage(true);
        },
        dismiss: function (e) {
            var view = this;
            view.message.dismiss();
            view.hide();
        },
    });
});
